// src/stone/illustrations/EasyTurningIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var EasyTurningIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 64, height: 64, fill: "#E8FEF3", rx: 4 }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M35.793 22.46a10.4 10.4 0 0 1-.319 2.558 10 10 0 0 1-.506 1.5q-.076.191-.168.381a10 10 0 0 1-.505.942 10.44 10.44 0 0 1-8.955 5.074h-3.786l-.037-11.95-.029-7.795h.946l7.156-.278q.227.102.45.214.389.193.75.418l-7.268.353c-.3.015-.294.482.008.468l7.913-.388.08.06a10.43 10.43 0 0 1 4.065 6.352c.134.673.206 1.373.205 2.09"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M31.34 26.132c-2.04 5.403-8.067 8.137-13.463 6.108a10.37 10.37 0 0 1-5.802-5.404l2.49-1.887a7.4 7.4 0 0 1-.301-1.125l-2.6 1.97a10 10 0 0 1-.198-.662l.034-.02 2.6-1.971.035-.584-.304.228-2.479 1.877a10.435 10.435 0 0 1 .427-5.83l.019-.05a10.48 10.48 0 0 1 9.688-6.777L25.318 12h.05a10.5 10.5 0 0 1 3.651.658q.289.11.571.234l-3.495.135q.622.299 1.188.667l3.508-.17q.004.001.008.004.334.201.645.43l-3.542.172a10.4 10.4 0 0 1 2.828 3.287 10.42 10.42 0 0 1 .61 8.714"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "M16.773 27.328v.001l.017.017 10.778-8.16-.013-.024zm0 0a6.8 6.8 0 0 1-1.588-2.441m1.588 2.441-1.588-2.441m0 0a7 7 0 0 1-.174-.52L25.19 16.66q.233.144.452.306a6.8 6.8 0 0 1 1.913 2.196zM12.266 25.998l-.01-.026 1.7-1.287.023.081-1.693 1.283z"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "easy-turning_Illustration_svg__a", fill: "#fff", children: /* @__PURE__ */ jsx("path", { d: "m11.664 25.794.006.019z" }) }),
      /* @__PURE__ */ jsx("path", { fill: "#FCFCFC", d: "m11.664 25.794.006.019z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m11.664 25.794.962-.274-.207-.726h-.755zm.006.019-.92.394 1.881-.669zm-.007-.019v-1h-1.325l.364 1.275zm-.96.275.008.028-.003-.01 1.923-.549-.005-.019-.003-.01v.001l.003.01zm1.886-.65a1 1 0 0 1 .036.1l-1.923.55q.014.055.049.138zm-.926 1.375h.001v-2z",
          mask: "url(#easy-turning_Illustration_svg__a)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M21.119 27.34c-.391 0-.796-.071-1.194-.214-1.48-.531-2.26-2.093-2.16-3.294a.135.135 0 0 1 .268.022c-.093 1.101.624 2.531 1.983 3.02.979.351 1.99.228 2.705-.328.54-.42.813-1.033.75-1.683-.119-1.226-.874-1.764-1.83-2.443l-.088-.062c-.978-.697-1.79-1.36-1.827-2.438a2.09 2.09 0 0 1 .878-1.78c.69-.503 1.647-.607 2.56-.279 1.09.391 1.682 1.357 1.873 2.132a.135.135 0 1 1-.262.065c-.175-.707-.714-1.588-1.703-1.943-.841-.302-1.684-.214-2.311.243a1.83 1.83 0 0 0-.767 1.553c.033.957.762 1.551 1.714 2.228l.087.062c.972.691 1.812 1.288 1.943 2.637.072.743-.239 1.444-.853 1.922-.492.382-1.11.58-1.766.58"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M19.536 28.164a.135.135 0 0 1-.127-.18l3.967-11.093a.135.135 0 0 1 .254.09l-3.967 11.094a.13.13 0 0 1-.127.089"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "easy-turning_Illustration_svg__b", fill: "#fff", children: /* @__PURE__ */ jsx("path", { d: "m14.135 22.557-.035.584-2.6 1.97a.2.2 0 0 1-.034.02 8 8 0 0 1-.114-.469l2.48-1.877c.098-.075.303-.228.303-.228" }) }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m14.135 22.557-.035.584-2.6 1.97a.2.2 0 0 1-.034.02 8 8 0 0 1-.114-.469l2.48-1.877c.098-.075.303-.228.303-.228"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m14.135 22.557.999.06.128-2.15-1.725 1.289zm-.035.584.604.797.367-.278.028-.46zm-2.6 1.97.6.8.004-.003zm-.034.02-.965.263.302 1.11 1.057-.453zm-.114-.469-.603-.797-.506.383.13.62zm2.48-1.877-.603-.798h-.001zm-.695-.288-.035.584 1.997.12.034-.584zm.36-.153-2.6 1.97 1.207 1.594 2.6-1.97zM10.9 24.31a1 1 0 0 1 .172-.098l.788 1.838c.119-.05.203-.112.24-.14zm1.531.559a7 7 0 0 1-.1-.414l-1.957.412q.057.27.127.526zm-.475.59 2.48-1.878-1.208-1.594-2.48 1.877zm2.478-1.877c.047-.036.122-.091.185-.14l.081-.06.025-.018.006-.005.002-.001-.598-.802-.598-.801-.002.002q-.003.001-.007.005l-.025.018-.274.206z",
          mask: "url(#easy-turning_Illustration_svg__b)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M16.439 27.973a.14.14 0 0 1-.093-.037 7.6 7.6 0 0 1-1.907-2.942 7.52 7.52 0 0 1 .052-5.2 7.5 7.5 0 0 1 1.316-2.232.134.134 0 1 1 .204.174 7.3 7.3 0 0 0-1.508 2.913 7.25 7.25 0 0 0 .19 4.253 7.3 7.3 0 0 0 1.839 2.838.135.135 0 0 1 .004.19.13.13 0 0 1-.097.043"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M42.791 26.427V52H13.03V45.5H11v-6.226h2.033v-6.36h19.134v-6.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "M45.358 51.5V26.927h1.912V51.5zM43.291 51.5V26.927h.07V51.5z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M49.966 32.653v6.624H52v6.227h-2.034V52H47.77V26.427H52v6.226zM44.858 26.427h-.996V52h.996z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#1D232A", d: "M32.167 39.012H31.15v6.663h1.017z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M27.562 52h3.59V32.916h-.965l-.811 5.899-.096.695-.811 5.897-.096.696z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M49.966 39.007v.269H13.033l-.01-.001h.01v-.268zM49.966 32.647H32.167v.268h17.799zM49.966 45.503H13.03v.269h36.936z"
        }
      )
    ]
  }
);
var EasyTurningIllustration_default = EasyTurningIllustration;

export {
  EasyTurningIllustration,
  EasyTurningIllustration_default
};
